module.exports = __webpack_public_path__ + "img/IndustrialThings.93883964.png";